import React from "react";
import { useIntl } from "react-intl";

import { User, Organisation } from "@auth/models";
import { AuthenticatedNav } from "../AuthenticatedNav";

interface HeaderStateProps {
    authenticated: boolean;
    canCreateAlbum: boolean;
    canViewUser: boolean;
    canViewDelivery: boolean;
    canGenerateReport: boolean;
    canViewReport: boolean;
    canViewBundle: boolean;
    canViewPlaylist: boolean;
    canViewGlobalStats: boolean;
    canViewSales: boolean;
    user: User;
    organisation: Organisation;
}

type Props = HeaderStateProps;

const Header = (props: Props) => {
    const { formatMessage } = useIntl();
    const {
        authenticated,
        ...otherProps
    } = props;

    if (authenticated) {
        return <AuthenticatedNav {...otherProps} formatMessage={formatMessage} />;
    }
    else {
        return (
            <div className="login-header">
                <div>
                    <h1 className="login-header__logo m-auto">
                        <span className="visually-hidden">Watamusic</span>
                    </h1>
                </div>
            </div>
        );
    }
};

export {
    HeaderStateProps,
    Header,
};
